import React, { Component } from "react";
import "../css/Home.css";
import Header from "./CHeader";
import {
  RemoveMember,
  ResendCredentials,
  ResendInvitaion,
  UpdateMembers,
} from "../Service";
import _ from "lodash-es";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import PaginationComponent from "react-reactstrap-pagination";
import MultiSelect from "react-multi-select-component";
import * as PapaParse from "papaparse";
import { Button, Modal } from "react-bootstrap";
import CAlert from "./CAlert";
import countryJson from "./country.json";
import * as Icon from 'react-bootstrap-icons';
import * as messages from "../message";
import * as strings from "../constants/Strings";
const fileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
const fileExtension = ".xlsx";
// eslint-disable-next-line no-useless-escape
const regex = new RegExp("^[a-zA-Z()À-ÖØ-öø-ÿ ,.]+$");
const emailregex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
// eslint-disable-next-line no-useless-escape
const countryregex = new RegExp("^[a-zA-Z()À-ÖØ-öø-ÿ ,.]+$");
// eslint-disable-next-line no-useless-escape
const lastnameregex = new RegExp("^[a-zA-Z()À-ÖØ-öø-ÿ ,.-]+$");
interface IState {
  membersRemoved: Array<any>;
  membersEnabled: Array<any>;
  iseditbarShow: boolean;
  members: Array<any>;
  dataloaded: boolean;
  selectedgroupId: string;
  pageSize: number;
  selectedPage: number;
  selectedMembers: Array<any>;
  searchMember: Array<any>;
  searchValue: string;
  alertmessage: string;
  allFilteredData: Array<any>;
  checkedListAll: Array<any>;
  ItemsChecked: boolean;
  selectedDropdown: any;
  showalert: boolean;
  alerttype: string;
  alertheading: string;
  isEdit: boolean;
  type: string;
  editmemberid: string;
  isBulk: boolean;
  excludedMembers: Array<any>;
  requestType: "Resend Invitation" | "Resend Credentials" | "";
  keychanged: boolean;
  removeid: string;
  sendtou: boolean;
  sendcredentials: boolean;
  sendInvitaion: boolean;
  addRemoved: boolean;
  membertype: string;
  membersForResend: Array<any>;
  flagRemoved: boolean;
  flagEditable: boolean;
  flagResendTou: boolean;
  flagResendCred: boolean;
  totalcheckedcount: number;
  editMembers: Array<any>;
  isUpdateDisabled: boolean;
  sortColumnBy: string;
  sortColumn: string;
  loading: boolean;
  isOpenBulkSelect: boolean;
}

interface IProps {
  memList: string;
  styleName?: string;
  addLicenses: boolean;
  loadingCallBack: Function;
  onUsersUpdate: Function;
  parentselectedGroupid: string;
  postOwnersCount: Function;
  selectedGroup?: any;
  data: Array<any>;
}

export class MembersList extends Component<IProps, IState> {
  private uploadedFileRef?: React.RefObject<HTMLInputElement>;
  private tableref?: React.RefObject<HTMLTableElement>;
  private dateRequestedRef?: React.RefObject<HTMLTableCellElement>;
  private accountTypeRef?: React.RefObject<HTMLTableCellElement>;
  private statusRef?: React.RefObject<HTMLTableCellElement>;
  private emailRef?: React.RefObject<HTMLTableCellElement>;
  private firstNameRef?: React.RefObject<HTMLTableCellElement>;
  private lastNameRef?: React.RefObject<HTMLTableCellElement>;
  private displayNameRef?: React.RefObject<HTMLTableCellElement>;
  private countryRef?: React.RefObject<HTMLTableCellElement>;
  private companyRef?: React.RefObject<HTMLTableCellElement>;
  private speakersGroupRef?: React.RefObject<HTMLTableCellElement>;
  private sponsorsGroupRef?: React.RefObject<HTMLTableCellElement>;
  private attendeesGroupRef?: React.RefObject<HTMLTableCellElement>;
  private organizersGroupRef?: React.RefObject<HTMLTableCellElement>;
  private userIdRef?: React.RefObject<HTMLTableCellElement>;
  private accountCreatedDateRef?: React.RefObject<HTMLTableCellElement>;
  private credentialsSentDateRef?: React.RefObject<HTMLTableCellElement>;
  private guestInviteSentDateRef?: React.RefObject<HTMLTableCellElement>;
  constructor(props: IProps) {
    super(props);
    this.uploadedFileRef = React.createRef();
    this.tableref = React.createRef();
    this.dateRequestedRef = React.createRef();
    this.accountTypeRef = React.createRef();
    this.statusRef = React.createRef();
    this.emailRef = React.createRef();
    this.firstNameRef = React.createRef();
    this.lastNameRef = React.createRef();
    this.displayNameRef = React.createRef();
    this.countryRef = React.createRef();
    this.companyRef = React.createRef();
    this.speakersGroupRef = React.createRef();
    this.sponsorsGroupRef = React.createRef();
    this.attendeesGroupRef = React.createRef();
    this.organizersGroupRef = React.createRef();
    this.userIdRef = React.createRef();
    this.accountCreatedDateRef = React.createRef();
    this.credentialsSentDateRef = React.createRef();
    this.guestInviteSentDateRef = React.createRef();

    this.state = {
      membersEnabled: [],
      membersRemoved: [],
      members: [],
      totalcheckedcount: 0,
      iseditbarShow: true,
      editMembers: [],
      dataloaded: true,
      selectedgroupId: props.parentselectedGroupid,
      pageSize: 10,
      alertmessage: "",
      selectedPage: 1,
      selectedMembers: [],
      searchMember: [],
      searchValue: "",
      allFilteredData: [],
      checkedListAll: [],
      ItemsChecked: false,
      selectedDropdown: [],
      alerttype: "",
      showalert: false,
      alertheading: "",
      isEdit: false,
      type: "Members",
      editmemberid: "",
      isBulk: false,
      excludedMembers: [],
      requestType: "",
      keychanged: true,
      removeid: "",
      sendtou: false,
      sendcredentials: false,
      sendInvitaion: false,
      membertype: "",
      membersForResend: [],
      addRemoved: false,
      flagRemoved: false,
      flagEditable: false,
      flagResendTou: false,
      flagResendCred: false,
      isUpdateDisabled: false,
      sortColumnBy: "",
      sortColumn: "",
      loading: false,
      isOpenBulkSelect: false
    };

    this.handleCheckboxClick = this.handleCheckboxClick.bind(this);
    this.selectedItems = this.selectedItems.bind(this);
    this.selectItem = this.selectItem.bind(this);
    this.sort = this.sort.bind(this);
    this.exportToCSV = this.exportToCSV.bind(this);
    this.sendCredentials = this.sendCredentials.bind(this);
    this.rowsSet = this.rowsSet.bind(this);
    this.Paginate = this.Paginate.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.getOptions = this.getOptions.bind(this);
    this.resendCredClick = this.resendCredClick.bind(this);
    this.resendInvitaion = this.resendInvitaion.bind(this);
    this.sendResendInvitaion = this.sendResendInvitaion.bind(this);
    this.setMemberProperty = this.setMemberProperty.bind(this);
    this.setalertparameters = this.setalertparameters.bind(this);
    this.updateRow = this.updateRow.bind(this);
    this.updateBulk = this.updateBulk.bind(this);
    this.cancelRow = this.cancelRow.bind(this);
    this.getTitle = this.getTitle.bind(this);
    this.Remove = this.Remove.bind(this);
    this.setUpdateDisabled = this.setUpdateDisabled.bind(this);
    this.removeClick = this.removeClick.bind(this);
    this.editData = this.editData.bind(this);
  }
  async editData() {
    let type = this.props.memList === "Members" ? "Member" : "Owner";
    const enabledMembers = this.getAllowedOrNotAllowedMembers(true);
    const nonEnabledMembers = this.getAllowedOrNotAllowedMembers(false);
    if (this.state.checkedListAll.length) {
      if (nonEnabledMembers.length && !enabledMembers.length) {
        this.setalertparameters(
          messages.editError,
          "error",
          "Error"
        );
        this.setState({
          checkedListAll: [],
          ItemsChecked: false,
          membersForResend: [],
        });
      } else if (!nonEnabledMembers.length && enabledMembers.length) {
        this.updateBulk();
      } else if (nonEnabledMembers.length && enabledMembers.length) {
        this.setalertparameters(
          messages.editNotEnabledSkipped
            .replace("{count}", `${nonEnabledMembers.length}`)
        );
        this.setState({
          checkedListAll: [],
          ItemsChecked: false,
          membersForResend: [],
        });
        this.updateBulk();
      }
    } else {
      this.setalertparameters(
        messages.editNotSelectedAnyMemberError,
        "error",
        "Error"
      );
      this.setState({
        checkedListAll: [],
        ItemsChecked: false,
        membersForResend: [],
      });
    }
    this.setState({
      checkedListAll: this.state.checkedListAll.filter(
        (id) => !nonEnabledMembers.find((item) => item?.id === id)
      ),
    });
  }
  async updateBulk() {
    try {
      this.props.loadingCallBack(true);
      this.setState({
        editmemberid: "0",
        isEdit: true,
        isBulk: true,
        pageSize: 20,
        selectedPage: 1,
      });
      this.props.loadingCallBack(false);
    } catch {
      this.setalertparameters(messages.bulkDataEditingError, "error", "Error");
    }
  }

  async cancelRow() {
    this.loadTableData();
    this.setState({
      checkedListAll: [],
      ItemsChecked: false,
      isEdit: false,
      isBulk: false,
      sortColumn: "",
      sortColumnBy: ""
    });
  }

  findCountryCodeFromList(name: string) {
    let country = null;
    if (name) {
      if (name.length === 2)
        country = countryJson.countries.find(
          (country) => country.countryCode.toLowerCase() === name.toLowerCase()
        );
      else
        country = countryJson.countries.find(
          (country) => country.displayName.toLowerCase() === name.toLowerCase()
        );
      if (country)
        if (name.length === 2) return country.displayName;
        else return country.countryCode;
      return "Not Found";
    }
    return "";
  }

  getCountryName(name: string) {
    if (name) {
      let country = null;
      if (name.length === 2)
        country = countryJson.countries.find(
          (country) => country.countryCode.toLowerCase() === name.toLowerCase()
        );
      else
        country = countryJson.countries.find(
          (country) => country.displayName.toLowerCase() === name.toLowerCase()
        );
      if (country) return country.displayName;
      return "Not Found";
    }
    return "";
  }
  async updateRow() {
    try {
      let editedMember = this.state.members.filter(
        (x) => x.status === "Enabled"
      );
      if (!_.isEmpty(this.state.checkedListAll)) {
        editedMember = editedMember.filter((member) =>
          this.state.checkedListAll.includes(member.id)
        );
      }
      if (editedMember.length === 1 && editedMember[0].status !== "Enabled") {
        this.setalertparameters(
          messages.editError,
          "error",
          "Error"
        );
        return;
      }
      let filteredData = editedMember.filter(
        (member) =>
          member.status !== "Processed" &&
          member.firstName !== "" &&
          member.disName !== "" &&
          member.lastName !== "" &&
          member.title !== "" &&
          (member.status === "Submitted" ? true : member.accountid) &&
          (this.state.editmemberid !== "0"
            ? member.id === this.state.editmemberid
            : true)
      );
      if (filteredData.length > 0) {
        filteredData = filteredData.map((value) => {
          return {
            ...value,
            sponsersGroup: value.sponsorsGroup === "true" ? true : false,
          };
        });
        for (var index = 0; index < filteredData.length; index++) {
          if (filteredData[index].country === "")
            filteredData[index].country = "US";
          filteredData[index].IsEdited = true;
        }
        this.props.loadingCallBack(true);
        await UpdateMembers(
          filteredData,
          this.state.selectedgroupId,
          this.props.memList
        ).subscribe((response: any) => {
          if (response.status === "Error") {
            this.props.loadingCallBack(false);
            this.setalertparameters(response.message, "error", "Error");
            return;
          }
          if (response.status === 404) {
            this.props.loadingCallBack(false);
            window.location.reload();
            return;
          }
          if (response?.status === 200 || response?.status === 204) {
            let count = filteredData.length;
            let removedmails = response.data.map((x: any) => x.title);
            if (response.data.length === 0) {
              this.setalertparameters(
                messages.editMemberSuccess
                  .replace("{count}", `${count}`),
                "success",
                "Success"
              );
              this.setState({
                checkedListAll: [],
                ItemsChecked: false,
                isEdit: false,
                isBulk: false,
                sortColumn: "",
                sortColumnBy: ""
              });
              this.props.loadingCallBack(false);
            } else {
              if (removedmails.length > 0) {
                let emailsnotfound = "<ul>";
                for (var i = 0; i < removedmails.length; i++) {
                  emailsnotfound =
                    emailsnotfound + "<li>" + removedmails[i] + "</li>";
                }
                emailsnotfound = emailsnotfound + "</ul>";
                this.setalertparameters(
                  `<div> ${messages.emailNotFoundSkipped
                    .replace("{emailsnotfound}", `${emailsnotfound}`)
                    } .<div>${messages.editMemberSuccess
                      .replace("{count}", `${count}`)
                      }`,
                  "success",
                  "Success"
                );
              }
            }
            this.setState({
              members: [
                {
                  firstName: "",
                  lastName: "",
                  displayname: "",
                  email: "",
                  country: "",
                  company: "",
                  speakersGroup: "false",
                  attendeesGroup: "false",
                  organizersGroup: "false",
                  userId: "",
                  sponsorsGroup: "false",
                  IsEdited: false,
                },
              ],
            });
            if (this.uploadedFileRef && this.uploadedFileRef.current) {
              this.uploadedFileRef.current.value = "";
            }
            this.props.onUsersUpdate(this.props.memList);
            this.setState({
              checkedListAll: [],
              ItemsChecked: false,
              isEdit: false,
              isBulk: false,
              sortColumn: "",
              sortColumnBy: ""
            });
          } else {
            this.setalertparameters(
              messages.addMemberOwnerError,
              "error",
              "Error"
            );

            this.setState({
              checkedListAll: [],
              ItemsChecked: false,
              isEdit: false,
              isBulk: false,
              sortColumn: "",
              sortColumnBy: ""
            });
            return;
          }
        });
      }
    } catch {
      this.setalertparameters(messages.addMemberError, "error", "Error");
    }
  }

  async componentDidMount() {
    this.loadTableData();
  }

  loadTableData() {
    const { data, parentselectedGroupid } = this.props;
    const { pageSize } = this.state;

    let mydata = [];
    for (var i = 0; i < pageSize; i++) {
      if (data[i]) {
        mydata.push(data[i]);
      }
    }
    this.setState({
      allFilteredData: data,
      members: data,
      selectedMembers: mydata,
      selectedgroupId: parentselectedGroupid,
      sortColumn: "",
      sortColumnBy: "",
      selectedDropdown: []
    });
  }

  async componentDidUpdate(prevProps: IProps, prevState: IState) {
    if (this.props.data !== prevProps.data) {
      this.loadTableData();
    }
    if (prevState.selectedDropdown !== this.state.selectedDropdown) {
      if (this.state.selectedDropdown.hasOwnProperty(strings.createdDate))
        this.removeAriaAttributes(this.dateRequestedRef?.current, this.getOptions(strings.createdDate).length, "");
      if (this.state.selectedDropdown.hasOwnProperty(strings.accountType))
        this.removeAriaAttributes(this.accountTypeRef?.current, this.getOptions(strings.accountType).length, "");
      if (this.state.selectedDropdown.hasOwnProperty(strings.status))
        this.removeAriaAttributes(this.statusRef?.current, this.getOptions(strings.status).length, "");
      if (this.state.selectedDropdown.hasOwnProperty(strings.title))
        this.removeAriaAttributes(this.emailRef?.current, this.getOptions(strings.title).length, "");
      if (this.state.selectedDropdown.hasOwnProperty(strings.firstName))
        this.removeAriaAttributes(this.firstNameRef?.current, this.getOptions(strings.firstName).length, "");
      if (this.state.selectedDropdown.hasOwnProperty(strings.lastName))
        this.removeAriaAttributes(this.lastNameRef?.current, this.getOptions(strings.lastName).length, "");
      if (this.state.selectedDropdown.hasOwnProperty(strings.disName))
        this.removeAriaAttributes(this.displayNameRef?.current, this.getOptions(strings.disName).length, "");
      if (this.state.selectedDropdown.hasOwnProperty(strings.country))
        this.removeAriaAttributes(this.countryRef?.current, this.getOptions(strings.country).length, "");
      if (this.state.selectedDropdown.hasOwnProperty(strings.company))
        this.removeAriaAttributes(this.companyRef?.current, this.getOptions(strings.company).length, "");
      if (this.state.selectedDropdown.hasOwnProperty(strings.speakersGroup))
        this.removeAriaAttributes(this.speakersGroupRef?.current, 2, "");
      if (this.state.selectedDropdown.hasOwnProperty(strings.sponsorsGroup))
        this.removeAriaAttributes(this.sponsorsGroupRef?.current, 2, "");
      if (this.state.selectedDropdown.hasOwnProperty(strings.attendeesGroup))
        this.removeAriaAttributes(this.attendeesGroupRef?.current, 2, "");
      if (this.state.selectedDropdown.hasOwnProperty(strings.organizersGroup))
        this.removeAriaAttributes(this.organizersGroupRef?.current, 2, "");
      if (this.state.selectedDropdown.hasOwnProperty(strings.userId))
        this.removeAriaAttributes(this.userIdRef?.current, this.getOptions(strings.userId).length, "");
      if (this.state.selectedDropdown.hasOwnProperty(strings.accountCreatedDate))
        this.removeAriaAttributes(this.accountCreatedDateRef?.current, this.getOptions(strings.accountCreatedDate).length, "");
      if (this.state.selectedDropdown.hasOwnProperty(strings.credentialsSentDate))
        this.removeAriaAttributes(this.credentialsSentDateRef?.current, this.getOptions(strings.credentialsSentDate).length, "");
      if (this.state.selectedDropdown.hasOwnProperty(strings.guestInviteSentDate))
        this.removeAriaAttributes(this.guestInviteSentDateRef?.current, this.getOptions(strings.guestInviteSentDate).length, "");
    }
  }

  handleCheckboxClick(e: { target: { value: any; checked: any } }) {
    const { value, checked } = e.target;
    this.setState({ flagRemoved: false });
    this.setState({ flagEditable: false });
    this.setState({ flagResendTou: false });
    this.setState({ flagResendCred: false });
    if (value) {
      if (checked) {
        let n: any =
          this.state.members.filter(
            (x: { id: any; status: any }) =>
              x.status === "Enabled" &&
              (x.id === value ||
                (this.state.checkedListAll.length === 0
                  ? true
                  : this.state.checkedListAll.includes((y: any) => {
                    return y === value;
                  })))
          ).length > 0;

        if (!n)
          this.setState({
            flagEditable: !n,
            flagResendTou: n,
            flagResendCred: n,
            flagRemoved: n,
          });
        else
          this.setState({
            flagEditable: true,
            flagResendTou: false,
            flagResendCred: false,
            flagRemoved: false,
          });

        this.setState((prevState) => ({
          checkedListAll: [...prevState.checkedListAll, value],
          ItemsChecked:
            this.state.selectedMembers.length ===
            prevState.checkedListAll.length + 1,
        }));
      } else {
        this.setState((prevState) => ({
          checkedListAll: prevState.checkedListAll.filter(
            (item) => item !== value
          ),
          ItemsChecked: false,
        }));

        let n: any =
          this.state.members.filter(
            (x: { id: any; status: any }) =>
              x.status === "Enabled" &&
              (x.id !== value ||
                (this.state.checkedListAll.length === 0
                  ? true
                  : this.state.checkedListAll.includes((y: any) => {
                    return y !== value;
                  })))
          ).length > 0;

        if (!n)
          this.setState({
            flagEditable: n,
            flagResendTou: !n,
            flagResendCred: !n,
            flagRemoved: !n,
          });
        else
          this.setState({
            flagEditable: true,
            flagResendTou: false,
            flagResendCred: false,
            flagRemoved: false,
          });
      }
    }
  }

  async selectedItems(e: { target: { value: any; checked: any } }) {
    const { value, checked } = e.target;
    let { checkedListAll } = this.state;
    if (checked) {
      checkedListAll = [...checkedListAll, value];
    } else {
      checkedListAll = checkedListAll.filter((el) => el === value);
      if (this.state.ItemsChecked) {
        this.state.selectedMembers.filter((r) => r.status);
        this.setState({
          ItemsChecked: !this.state.ItemsChecked,
        });
      }
    }
    this.setState({ checkedListAll });
  }
  async selectItem(e: { target: { checked: any } }) {
    const { checked } = e.target;
    const collection = [];

    if (checked) {
      for (const cat of this.state.allFilteredData.length !== 0
        ? this.state.allFilteredData
        : this.state.members) {
        collection.push(cat.id);
      }
      let chk: any = [];
      chk = collection;

      let x: any = null;
      x =
        chk.filter(function (x: { status: string }) {
          return !(x.status === "Enabled");
        }).length > 0;

      if (typeof x === undefined) x = false;
      this.setState({
        flagEditable: x,
        flagResendTou: x,
        flagResendCred: x,
        flagRemoved: x,
      });
    } else {
      this.setState({
        flagRemoved: false,
        flagEditable: false,
        flagResendTou: false,
        flagResendCred: false,
      });
    }

    this.setState({
      checkedListAll: collection,
      ItemsChecked: checked,
    });
  }

  async resendCredClick() {
    try {
      if (this.state.checkedListAll.length === 0) {
        this.setalertparameters(
          messages.editNotSelectedAnyMemberError,
          "error",
          "Error"
        );
        return;
      }
      let collection: any[] = [];
      collection = this.state.checkedListAll.filter((mem) => mem);
      if (collection.length) {
        let validids: any[] = [];
        let invalidids: any[] = [];
        let invalidwithnopwd: any[] = [];
        let invalidwithProcessed: any[] = [];
        this.setState({ totalcheckedcount: collection.length });
        this.state.checkedListAll.forEach((x: string) => {
          let mem = this.state.members.find((mem) => mem.id === x);
          if (
            mem.accountid &&
            mem.status === "Enabled" &&
            mem.accountType === "Member" &&
            mem.tempPassword !== null
          ) {
            validids.push(mem.id);
          } else if (
            mem.accountid &&
            mem.status === "Enabled" &&
            mem.accountType === "Member" &&
            mem.tempPassword === null
          ) {
            invalidwithnopwd.push(mem.id);
          } else if (
            mem.accountid &&
            mem.accountType === "Member" &&
            mem.status !== "Processed"
          ) {
            invalidids.push(mem.id);
          } else if (
            mem.accountid &&
            mem.accountType === "Member" &&
            mem.tempPassword !== null &&
            mem.status === "Processed"
          ) {
            invalidwithProcessed.push(mem.id);
          }
        });

        if (validids.length !== 0)
          this.setState({ sendcredentials: true, checkedListAll: validids });
        else {
          if (invalidwithnopwd.length > 0)
            this.setalertparameters(
              messages.resendCredentialsErrorwithNopwd, 
              "error",
              "Error"
            );
          else if (
            invalidwithProcessed.length >= 0 &&
            this.state.checkedListAll.length - invalidwithProcessed.length === 0
          ) {
            this.props.memList === "Members"
              ? this.setalertparameters(
                messages.resendCredentialsError
                .replace(
                  "{type}",
                  this.props.memList === "Members" ? "Member" : "Owner"
                ),
                "error",
                "Error"
              )
              : this.setalertparameters(
                messages.resendCredentialsErrorwithOwner,
                "error",
                "Error"
              );
          } else if (invalidids.length >= 0) {
            this.props.memList === "Members"
              ? this.setalertparameters(
                messages.resendCredentialsError
                  .replace(
                    "{type}",
                    this.props.memList === "Members" ? "Member" : "Owner"
                  ),
                "error",
                "Error"
              )
              : this.setalertparameters(
                messages.resendCredentialsErrorwithOwner,
                "error",
                "Error"
              );
          }
          else {
            this.props.memList === "Members"
              ? this.setalertparameters(
                messages.resendCredentialsError 
                .replace(
                  "{type}",
                  this.props.memList === "Members" ? "Member" : "Owner"
                ),
                "error",
                "Error"
              )
              : this.setalertparameters(
                messages.resendCredentialsErrorwithOwner,
                "error",
                "Error"
              );
          }
          this.setState({
            checkedListAll: [],
            ItemsChecked: false,
            membersForResend: [],
          });
          this.props.loadingCallBack(false);
        }
      } else {
        this.setalertparameters(
          messages.resendCredentialErrorCatch,
          "error",
          "Error"
        );
      }
    } catch {
      this.setalertparameters(
        messages.resendCredentialErrorCatch,
        "error",
        "Error"
      );
    }
  }

  async sendCredentials(members: any) {
    try {
      this.props.loadingCallBack(true);
      this.setState({ sendcredentials: false })
      let collection: any[] = [];
      members.forEach((x: string) => {
        let mem = this.state.members.find((mem) => mem.id === x);
        if (mem.status === "Enabled" && mem.tempPassword !== null) {
          collection.push(mem);
        }
      });
      let num: number = 0;
      num = this.state.totalcheckedcount;
      ResendCredentials(collection).subscribe((result: any) => {
        if (result && result.data && result.data.isSuccessStatusCode) {
          if (num - collection.length > 0 && collection.length > 0) {
            if (collection.length !== num)
              this.setalertparameters(
                messages.resendCredentialBulkSuccess
                  .replace(
                    "{skippedNumber}",
                    (num - collection.length).toString()
                  )
                  .replace(
                    "{resendCredentialCount}",
                    collection.length.toString()
                  ),
                "success",
                "Success"
              );
            else if (collection.length === num && collection.length > 1)
              this.setalertparameters(
                messages.resendCredentialBulkSuccess
                  .replace(
                    "{skippedNumber}",
                    (num - collection.length).toString()
                  )
                  .replace(
                    "{resendCredentialCount}",
                    collection.length.toString()
                  ),
                "success",
                "Success"
              );
            else
              this.setalertparameters(
                messages.resendCredentialSuccess
                  .replace("{count}", collection.length.toString())
                  .toString(),
                "success",
                "Success"
              );
            this.setState({
              checkedListAll: [],
              ItemsChecked: false,
              sendtou: false,
              membersForResend: [],
            });
            this.props.loadingCallBack(false);
            return;
          } else if (num - collection.length === 0 && collection.length > 0) {
            if (collection.length === num && collection.length > 1)
              this.setalertparameters(
                messages.resendCredentialBulkSuccess
                  .replace(
                    "{skippedNumber}",
                    (num - collection.length).toString()
                  )
                  .replace(
                    "{resendCredentialCount}",
                    collection.length.toString()
                  ),
                "success",
                "Success"
              );
            else
              this.setalertparameters(
                messages.resendCredentialSuccess
                  .replace("{count}", collection.length.toString()),
                "success",
                "Success"
              );
            this.setState({
              checkedListAll: [],
              ItemsChecked: false,
              sendtou: false,
              membersForResend: [],
            });
            this.props.loadingCallBack(false);
            return;
          } else {
            this.setalertparameters(
              messages.resendCredentialSuccess
                .replace("{count}", collection.length.toString()),
              "success",
              "Success"
            );
            this.setState({
              checkedListAll: [],
              ItemsChecked: false,
            });
            this.props.loadingCallBack(false);
          }
        }
        else {
          this.setalertparameters(result && result.data && result.data.reasonPhrase ? result.data.reasonPhrase : messages.resendCredentialErrorCatch, "error", "Error");
        }
        this.props.loadingCallBack(false);
      });
    } catch {
      this.setalertparameters(
        messages.resendCredentialErrorCatch,
        "error",
        "Error"
      );
    }
  }

  async resendInvitaion() {
    try {
      if (this.state.checkedListAll.length === 0) {
        this.setalertparameters(
          messages.editNotSelectedAnyMemberError,
          "error",
          "Error"
        );
        return;
      }
      let collection: any[] = [];
      let collectionwithnourl: any[] = [];
      collection = this.state.checkedListAll.filter((mem) => mem);

      this.setState({ totalcheckedcount: collection.length });
      if (collection.length) {
        let validids: any[] = [];
        this.state.checkedListAll.forEach((x: string) => {
          let mem = this.state.members.find((mem) => mem.id === x);

          if (
            mem.accountid &&
            new Date(mem.touAcceptedDate).toLocaleDateString() !== strings.invalideDate &&
            mem.status === "Enabled" &&
            mem.guestInviteURL !== null
          ) {
            validids.push(mem.id);
          } else if (
            mem.accountid &&
            new Date(mem.touAcceptedDate).toLocaleDateString() !== strings.invalideDate &&
            mem.status === "Enabled" &&
            mem.guestInviteURL === null
          ) {
            collectionwithnourl.push(mem.id);
          }
        });
        if (validids.length !== 0)
          this.setState({ sendInvitaion: true, checkedListAll: validids });
        else {
          if (
            collectionwithnourl.length !== 0 &&
            this.state.checkedListAll.length - collectionwithnourl.length === 0
          )
            this.setalertparameters(
              messages.resendInvitationErrorwithnoguest,
              "error",
              "Error"
            );
          else
            this.setalertparameters(
              messages.resendInvitationError,
              "error",
              "Error"
            );
          this.setState({
            checkedListAll: [],
            ItemsChecked: false,
            membersForResend: [],
          });
          this.props.loadingCallBack(false);
        }
      } else {
        this.setalertparameters(
          messages.resendInvitationError,
          "error",
          "Error"
        );
        this.setState({
          checkedListAll: [],
          ItemsChecked: false,
          membersForResend: [],
        });
        this.props.loadingCallBack(false);
      }
    } catch {
      this.setalertparameters(messages.resendInvitationErrorCatch, "error", "Error");
      this.setState({
        checkedListAll: [],
        ItemsChecked: false,
        membersForResend: [],
      });
      this.props.loadingCallBack(false);
    }
  }

  async sendResendInvitaion(members: any) {
    try {
      this.props.loadingCallBack(true);
      this.setState({ sendInvitaion: false })
      let collection: any[] = [];
      members.forEach((x: string) => {
        let mem = this.state.members.find((mem) => mem.id === x);
        if (mem.status === "Enabled" && mem.guestInviteURL !== null) {
          collection.push(mem);
        }
      });
      let num: number = 0;
      num = this.state.totalcheckedcount;

      ResendInvitaion(collection).subscribe((result: any) => {
        if (result && result.data && result.data.isSuccessStatusCode) {
          if (
            this.state.members.length - collection.length > 0 &&
            collection.length > 1
          ) {
            if (collection.length !== members.length)
              this.setalertparameters(
                messages.resendCredentialBulkSuccess
                  .replace(
                    "{skippedNumber}",
                    (this.state.members.length - collection.length).toString()
                  )
                  .replace(
                    "{resendInvitationCount}",
                    collection.length.toString()
                  ),
                "success",
                "Success"
              );
            this.setState({
              checkedListAll: [],
              ItemsChecked: false,
              sendInvitaion: false,
              membersForResend: [],
            });
            this.props.loadingCallBack(false);
          } else {
            this.setalertparameters(
              messages.resendInvitationSuccess
                .replace("{count}", collection.length.toString()),
              "success",
              "Success"
            );
            this.setState({
              checkedListAll: [],
              ItemsChecked: false,
              membersForResend: [],
            });
            this.props.loadingCallBack(false);
          }

          if (num - collection.length > 0 && collection.length > 0) {
            if (collection.length !== num)
              this.setalertparameters(
                messages.resendInvitationBulkSuccess
                  .replace(
                    "{skippedNumber}",
                    (num - collection.length).toString()
                  )
                  .replace(
                    "{resendInvitationCount}",
                    collection.length.toString()
                  ),
                "success",
                "Success"
              );
            else if (collection.length === num && collection.length > 1)
              this.setalertparameters(
                messages.resendInvitationBulkSuccess
                  .replace(
                    "{skippedNumber}",
                    (num - collection.length).toString()
                  )
                  .replace(
                    "{resendInvitationCount}",
                    collection.length.toString()
                  ),
                "success",
                "Success"
              );
            else
              this.setalertparameters(
                messages.resendInvitationSuccess
                  .replace("{count}", collection.length.toString()),
                "success",
                "Success"
              );

            this.setState({
              checkedListAll: [],
              ItemsChecked: false,
              sendInvitaion: false,
              membersForResend: [],
              sendcredentials: false,
            });
            this.props.loadingCallBack(false);
            return;
          } else if (num - collection.length === 0 && collection.length > 0) {
            if (collection.length === num && collection.length > 1)
              this.setalertparameters(
                messages.resendInvitationBulkSuccess
                  .replace(
                    "{skippedNumber}",
                    (num - collection.length).toString()
                  )
                  .replace(
                    "{resendInvitationCount}",
                    collection.length.toString()
                  ),
                "success",
                "Success"
              );
            else
              this.setalertparameters(
                messages.resendInvitationSuccess
                  .replace("{count}", collection.length.toString()),
                "success",
                "Success"
              );
            this.setState({
              checkedListAll: [],
              ItemsChecked: false,
              sendInvitaion: false,
              membersForResend: [],
              sendcredentials: false,
            });
            this.props.loadingCallBack(false);
            return;
          } else {
            this.setalertparameters(
              messages.resendInvitationSuccess
                .replace("{count}", collection.length.toString()),
              "success",
              "Success"
            );
            this.setState({
              checkedListAll: [],
              ItemsChecked: false,
              sendInvitaion: false,
            });
            this.props.loadingCallBack(false);
          }

        }
        else {
          this.setalertparameters(result && result.data && result.data.reasonPhrase ? result.data.reasonPhrase : messages.resendInvitationErrorCatch, "error", "Error");
        }
        this.props.loadingCallBack(false);
      });
    } catch {
      this.props.loadingCallBack(true);
      this.setalertparameters(
        messages.resendInvitationErrorCatch,
        "error",
        "Error"
      );
    }
  }

  getAllowedOrNotAllowedMembers(isEnableMembers: boolean) {
    let members: any[];

    if (isEnableMembers)
      members = this.state.members.filter(
        (x: { id: any; status: any }) =>
          x.status === "Enabled" &&
          this.state.checkedListAll.find((cid: any) => cid === x.id)
      );
    else
      members = this.state.members.filter(
        (x: { id: any; status: any }) =>
          x.status !== "Enabled" &&
          this.state.checkedListAll.find((cid: any) => cid === x.id)
      );
    return members;
  }

  removeClick() {
    if (this.state.checkedListAll.length === 0) {
      this.setalertparameters(
        messages.editNotSelectedAnyMemberError,
        "error",
        "Error"
      );
      this.setState({
        checkedListAll: [],
        ItemsChecked: false,
        membersForResend: [],
      });
    } else {
      const nonEnabledMembers = this.getAllowedOrNotAllowedMembers(false);
      if (this.state.checkedListAll.length === nonEnabledMembers.length) {
        this.setalertparameters(
          messages.removeMemberOwnerError,
          "error",
          "Error"
        );
        this.setState({
          checkedListAll: [],
          ItemsChecked: false,
          membersForResend: [],
        });
        this.props.loadingCallBack(false);
      } else {
        this.setState({ removeid: "true" });
      }
    }
  }

  async Remove() {
    try {
      this.setState({ removeid: "" });
      const enabledMembers = this.getAllowedOrNotAllowedMembers(true);
      const nonEnabledMembers = this.getAllowedOrNotAllowedMembers(false);
      RemoveMember(enabledMembers.map((item) => item.id)).subscribe(
        (result: any) => {
          if (result.status === "Error") {
            this.setalertparameters(result.message, "error", "Error");
            return;
          }
          if (result) {
            if (nonEnabledMembers.length) {
              this.setalertparameters(
                messages.removeBulkSuccess
                  .replace("{enableOwnerCount}", `${enabledMembers.length}`)
                  .replace("{skippedNumber}", `${nonEnabledMembers.length}`),
                "success",
                "Success"
              );
            } else {
              this.setalertparameters(
                messages.removeSuccess
                  .replace("{enableOwnerCount}", `${enabledMembers.length}`),
                "success",
                "Success"
              );
            }
            this.props.onUsersUpdate(this.props.memList);
            this.setState({
              checkedListAll: [],
              ItemsChecked: false,
              membersForResend: [],
              sortColumn: "",
              sortColumnBy: ""
            });
          } else {
            this.setalertparameters(messages.removeErrorCatch, "error", "Error");
          }
        }
      );
    } catch {
      this.setalertparameters(messages.removeErrorCatch, "error", "Error");
    }
  }

  async UpdateMember(id: string) {
    try {
      let m: any = [];
      m = this.state.selectedMembers.filter(
        (x) => x.id === id && x.status === "Enabled"
      );

      let n: any = [];
      n = this.state.selectedMembers;
      this.setState({
        editmemberid: id,
        isEdit: true,
      });

      this.setalertparameters(
        `<div>${messages.resendCredentialBulkSkippedSuccess
          .replace("{count}", `${n.length - m.length}`)
         }<div>${messages.editMemberSuccess
            .replace("{count}", `${m.length}`)
            }`,
        "success",
        "Success"
      );
      setTimeout(() => {
        let pageBottom: any = document.querySelector("#page-bottom");
        pageBottom.scrollIntoView();
      }, 100);
    } catch {
      this.setalertparameters(messages.updatingMemberOwnerError, "error", "Error");
    }
  }

  setMemberProperty(index: number, key: string, value: string) {
    try {
      let members = this.state.members.map((member, inx) =>
        index === inx ? { ...member, [key]: value } : member
      );
      if (key === strings.title) {
        members.map((x: any) => (x.duplicateemail = false));
        if (
          this.state.members.findIndex(
            (x) => x.title.toLocaleLowerCase() === value.toLocaleLowerCase()
          ) !== -1
        ) {
          members[index].duplicateemail = true;
        }
      }
      this.setState(
        {
          members: members
        }
      );
    } catch {
      this.setalertparameters(messages.setMemberPropertyErrorCatch, "error", "Error");
    }
  }

  setUpdateDisabled(members: Array<any>) {
    let invalid = false;
    members.forEach((element: any) => {
      if (
        !element.firstName ||
        !element.lastName ||
        !element.disName ||
        (element.firstName && !regex.test(element.firstName)) ||
        (element.lastName && !lastnameregex.test(element.lastName)) ||
        (element.disName && element.disName.length > 64)
      ) {
        invalid = true;
      }
    });
    if (this.state.members.length === 0 || invalid) {
      if (!this.state.isUpdateDisabled)
        this.setState({ isUpdateDisabled: true })
    } else {
      if (this.state.isUpdateDisabled)
        this.setState({ isUpdateDisabled: false })
    }
  }

  async setalertparameters(
    message: string,
    type: string = "warning",
    heading: string = "Warning"
  ) {
    this.setState({
      alertmessage: message,
      alerttype: type,
      alertheading: heading,
      showalert: true,
    });
  }

  sort(key: string) {
    try {
      this.setState({ dataloaded: false });
      this.props.loadingCallBack(true);
      let orginalmembers = Object.assign({}, this.state.allFilteredData);
      let sortedmembers = _.orderBy(orginalmembers, [
        (user) => user[key] && user[key].toString().toLowerCase(),
      ]);
      if (key === "CreatedDate" || key === "TocDate") {
        sortedmembers = _.orderBy(orginalmembers, function (o) {
          return new Date(o[key]);
        });
      }
      if (sortedmembers[0] === orginalmembers[0]) {
        sortedmembers = sortedmembers.reverse();
      }
      let mysortedmembers = [];
      for (var i = 0; i < this.state.pageSize; i++) {
        if (sortedmembers[i]) {
          mysortedmembers.push(sortedmembers[i]);
        }
      }
      this.setState({
        allFilteredData: sortedmembers,
        dataloaded: true,
        selectedMembers: mysortedmembers,
        selectedPage: 1,
      });
      this.props.loadingCallBack(false);
    } catch {
      this.setalertparameters(messages.exportCsvError, "error", "Error");
    }
  }

  exportToCSV(csvData: any, fileName: any) {
    try {
      if (fileName === "memberupns") {
        let rows = [
          [
            "UPN",
          ],
          [""],
        ];
        let csvContent =
          "data:text/csv;charset=UTF-8,\ufeff" +
          rows.map((e) => e.join(",")).join("\n");
        const encodedUri = encodeURI(csvContent);
        let link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", `${fileName}.csv`);
        document.body.appendChild(link);
        link.click();
      }
      else {
        let type = this.props.memList === "Members" ? "Members" : "Owners";
        let sheetData = Array<any>();
        csvData.forEach((element: any) => {
          let data: any = {};
          data["Date Requested"] =
            new Date(element.createdDate).toLocaleDateString() !== strings.invalideDate
              ? new Date(element.createdDate).toDateString()
              : "";
          if (type === "Members") {
            data["Account Type"] = element.accountType;
          }
          data["Status"] = element.status;
          data["Email"] = element.title;
          data["First Name"] = element.firstName;
          data["Last Name"] = element.lastName;
          data["Display Name"] = element.disName;
          data["Country"] = this.getCountryName(element.country);
          data["Company"] = element.company;
          data["Speaker Group"] = element.speakersGroup;
          data["Sponsers Group"] = element.sponsorsGroup;
          data["Attendees Group"] = element.attendeesGroup;
          data["Organizers Group"] = element.organizersGroup;
          data["UPN"] = element.userId;
          data["Account Created"] =
            new Date(element.accountCreatedDate).toLocaleDateString() !== strings.invalideDate
              ? new Date(element.accountCreatedDate).toDateString()
              : "";
          data["Credentials Sent"] =
            new Date(element.credentialsSentDate).toLocaleDateString() !== strings.invalideDate
              ? new Date(element.credentialsSentDate).toDateString()
              : "";
          data["Guest Invitation Sent"] =
            new Date(element.guestInviteSentDate).toLocaleDateString() !== strings.invalideDate
              ? new Date(element.guestInviteSentDate).toDateString()
              : "";
          sheetData.push(data);
        });
        let ws = XLSX.utils.json_to_sheet(sheetData);
        let wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        let excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        let data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(
          data,
          this.props.selectedGroup.title +
          `_` +
          type +
          `_` +
          new Date().toLocaleDateString() +
          fileExtension
        );
      }
    } catch {
      this.setalertparameters(messages.exportCsvError, "error", "Error");
    }
  }

  Paginate(selectedpage: any) {
    try {
      let orginalevents = Object.assign({}, this.state.allFilteredData);
      let myevents: any = [];
      let toindex = selectedpage * this.state.pageSize;
      let fromindex = toindex - this.state.pageSize;
      for (let i = fromindex; i < toindex; i++) {
        if (orginalevents[i]) myevents.push(orginalevents[i]);
      }
      this.setState({ selectedMembers: myevents, selectedPage: selectedpage });
    } catch {
      this.setalertparameters(messages.exportCsvError, "error", "Error");
    }
  }

  rowsSet(event: any, allData: any, isSearch: boolean) {
    if (isSearch) {
      try {
        let orginalevents = Object.assign({}, allData);
        let myevents: any = [];
        let toindex = 1 * event;
        let fromindex = toindex - event;
        for (let i = fromindex; i < toindex; i++) {
          if (orginalevents[i]) myevents.push(orginalevents[i]);
        }
        this.setState({
          selectedMembers: myevents,
          pageSize: event,
          selectedPage: 1,
          allFilteredData: allData,
        });
        if (this.state.sortColumn !== "" && this.state.sortColumnBy !== "") {

          setTimeout(() => {

            this.sortTableData(this.state.sortColumn, this.state.sortColumnBy);

          }, 100);

        }
      } catch {
        this.setalertparameters(messages.exportCsvError, "error", "Error");
      }
    } else {
      try {
        let orginalevents = Object.assign({}, this.state.allFilteredData);
        let myevents: any = [];
        let toindex = 1 * event?.target?.value;
        let fromindex = toindex - event?.target?.value;
        for (let i = fromindex; i < toindex; i++) {
          if (orginalevents[i]) myevents.push(orginalevents[i]);
        }
        this.setState({
          selectedMembers: myevents,
          pageSize: event.target.value,
          selectedPage: 1,
          allFilteredData: this.state.allFilteredData,
        });
      } catch {
        this.setalertparameters(messages.exportCsvError, "error", "Error");
      }
    }
  }

  handleSearch(event: any) {
    this.setState({ searchValue: event.target.value });
    if (event.target.value !== "") {
      let allData = this.state.members.filter(
        (member) =>
          member.FirstName?.toString()
            .toLowerCase()
            .includes(event.target.value.toLowerCase()) ||
          member.LastName?.toString()
            .toLowerCase()
            .includes(event.target.value.toLowerCase()) ||
          member.Email?.toString()
            .toLowerCase()
            .includes(event.target.value.toLowerCase()) ||
          member.UserName?.toString()
            .toLowerCase()
            .includes(event.target.value.toLowerCase()) ||
          member.Status?.toString()
            .toLowerCase()
            .includes(event.target.value.toLowerCase())
      );
      this.rowsSet(this.state.pageSize, allData, true);
    } else {
      this.rowsSet(this.state.pageSize, this.state.members, true);
    }
  }

  applyFilter = (key: any, value: Array<any>) => {
    let newSelectedDropdown = this.state.selectedDropdown;
    if (_.isEmpty(value)) {
      delete newSelectedDropdown[key];
    } else {
      newSelectedDropdown = { ...this.state.selectedDropdown, [key]: value };
    }

    this.setState({ selectedDropdown: newSelectedDropdown }, () => {
      let objkeys = Object.keys(this.state.selectedDropdown);
      let allData: any;
      objkeys.forEach((obj: string) => {
        let data = this.state.selectedDropdown[obj]?.map(
          (data: any) => data.value
        );
        if (data && data.length > 0) {
          let filterdate = allData ? allData : this.state.members;
          let keydata = filterdate.filter((member: any) => {
            let a = true;
            if (!obj.toLowerCase().includes("date"))
              a =
                (!_.isEmpty(data)
                  ? _.includes(data, member[obj]?.toString())
                  : false) && a;
            else
              a =
                (!_.isEmpty(data)
                  ? _.includes(data, new Date(member[obj])?.toDateString())
                  : false) && a;
            return a;
          });
          allData = keydata;
        }
      });
      if (
        !allData ||
        (allData &&
          allData.length === 0 &&
          this.state.selectedDropdown.length === 0)
      )
        allData = this.state.members;
      this.rowsSet(this.state.pageSize, allData, true);
    });
  };

  inTeams() {
    try {
      return window.self !== window.top;
    } catch (e) {
      return true;
    }
  }

  getOptions(key: any): any {
    type option = { value: string, label: string }
    var optionarray: Array<option> = [];
    let options = this.state.members.map((x: any) => x[key]).filter(Boolean);
    options?.forEach((x) => {
      if (key.toLowerCase().includes("date")) {
        if (new Date(x).toLocaleDateString() !== strings.invalideDate) {
          optionarray.push({
            label: new Date(x).toDateString(),
            value: new Date(x).toDateString(),
          });
        }
      } else {
        if (key === strings.country)
          optionarray.push({ label: this.getCountryName(x), value: x });
        else
          optionarray.push({ label: x, value: x });

      }
    });
    if (key.toLowerCase().includes("date")) {
      optionarray = optionarray.sort((a: option, b: option) => {
        const aDate: any = new Date(a.value);
        const bDate: any = new Date(b.value);
        return bDate - aDate;
      })
    } else {
      optionarray = optionarray.sort((a: option, b: option) => {
        let fa = a.value.toLowerCase(), fb = b.value.toLowerCase();
        if (fa < fb) {
          return -1;
        }
        if (fa > fb) {
          return 1;
        }
        return 0;
      })
    }
    return _.uniqBy(optionarray, "value");
  }

  addMembers(title: any) {
    const { members } = this.state;
    let allEditData = members.filter((member) =>
      this.state.editmemberid !== "0"
        ? member.id === this.state.editmemberid
        : true
    );

    allEditData = members.map((ele, index) => {
      return { ...ele, memberIndex: index };
    });
    if (!_.isEmpty(this.state.checkedListAll)) {
      allEditData = allEditData.filter((member) =>
        this.state.checkedListAll.includes(member.id)
      );
    }
    allEditData = allEditData.filter((x) => x.status === "Enabled");
    let orginalevents = Object.assign({}, allEditData);
    let myevents: any = [];
    let toindex = this.state.selectedPage * this.state.pageSize;
    let fromindex = toindex - this.state.pageSize;
    for (let i = fromindex; i < toindex; i++) {
      if (orginalevents[i]) myevents.push(orginalevents[i]);
    }
    this.setUpdateDisabled(myevents);
    return (
      <div>
        <div className="mt-3 mb-2 card cd">
          <table className="table">
            <thead className="thead-light">
              <tr id={"page-bottom"}>
                <th>Email</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Display Name</th>
                <th>Country</th>
                <th>Company</th>
                <th className="th-wd">Speakers Group</th>
                <th className="th-wd">Sponsors Group</th>
                <th className="th-wd">Attendees Group</th>
                <th className="th-wd">Organizers Group</th>
                <th>UPN</th>
              </tr>
            </thead>
            <tbody>
              {myevents.map((member: any, inx: any) => (
                <tr key={inx}>
                  <td>
                    <input
                      type="email"
                      className="form-control"
                      value={member.title || ""}
                      placeholder="Email Id"
                      disabled={this.state.isEdit}
                      pattern={emailregex.toString()}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      className="form-control text-capitalize	"
                      value={member.firstName || ""}
                      placeholder="First Name"
                      disabled={member.status !== "Enabled"}
                      onChange={(event) =>
                        this.setMemberProperty(
                          member.memberIndex,
                          strings.firstName,
                          event.target.value
                        )
                      }
                    />
                    {member.firstName && !regex.test(member.firstName) && (
                      <span className="email-validation">
                        {messages.firstNameInvalidValidError}
                      </span>
                    )}
                    {member.firstName && member.firstName.length > 255 && (
                      <p className="email-validation">{messages.firstNameLength}</p>
                    )}
                    {!member.firstName && (
                      <p className="email-validation">{messages.firstNameRequiredError}</p>
                    )}
                  </td>
                  <td>
                    <input
                      type="text"
                      className="form-control text-capitalize	"
                      value={member.lastName || ""}
                      placeholder="Last Name"
                      disabled={member.status !== "Enabled"}
                      onChange={(event) =>
                        this.setMemberProperty(
                          member.memberIndex,
                          strings.lastName,
                          event.target.value
                        )
                      }
                    />
                    {member.lastName &&
                      !lastnameregex.test(member.lastName) && (
                        <span className="email-validation">
                          {messages.lastNameInvalidValidError}
                        </span>
                      )}
                    {member.lastName && member.lastName.length > 255 && (
                      <p className="email-validation">{messages.lastNameLength}</p>
                    )}
                    {!member.lastName && (
                      <p className="email-validation">{messages.lastNameRequiredError}</p>
                    )}
                  </td>
                  <td>
                    <input
                      type="text"
                      className="form-control"
                      value={member.disName || ""}
                      placeholder="Display Name"
                      disabled={member.status !== "Enabled"}
                      onChange={(event) =>
                        this.setMemberProperty(
                          member.memberIndex,
                          strings.disName,
                          event.target.value
                        )
                      }
                    />
                    {member.disName && member.disName.length > 64 && (
                      <p className="email-validation">{messages.displayNameLength}</p>
                    )}
                    {!member.disName && (
                      <p className="email-validation">{messages.displayNameRequiredError}</p>
                    )}
                  </td>
                  <td>
                    <select
                      className="form-control"
                      id="country"
                      value={member.country}
                      disabled={member.status !== "Enabled"}
                      onChange={(event) =>
                        this.setMemberProperty(
                          member.memberIndex,
                          strings.country,
                          event.target.value
                        )
                      }
                    >
                      <option value="">Select</option>
                      {(countryJson.countries || []).map((value, id) => (
                        <option key={id} value={value.countryCode}>
                          {value.displayName}
                        </option>
                      ))}
                    </select>
                    {member.country && !countryregex.test(member.country) && (
                      <span className="email-validation">
                        Country contains disallowed characters.
                      </span>
                    )}
                    {member.country && member.country.length > 255 && (
                      <p className="email-validation">
                        Country exceeds the 255 characters.
                      </p>
                    )}
                  </td>
                  <td>
                    <input
                      type="text"
                      className="form-control text-capitalize	"
                      value={member.company || ""}
                      placeholder="Company"
                      maxLength={64}
                      disabled={member.status !== "Enabled"}
                      onChange={(event) =>
                        this.setMemberProperty(
                          member.memberIndex,
                          strings.company,
                          event.target.value
                        )
                      }
                    />
                    {member.company && member.company.length > 64 && (
                      <p className="email-validation">
                        {messages.companyLength}
                      </p>
                    )}
                  </td>
                  <td>
                    <select
                      className="form-control"
                      disabled={member.status !== "Enabled"}
                      id="speaker"
                      value={member.speakersGroup || false}
                      onChange={(event) =>
                        this.setMemberProperty(
                          member.memberIndex,
                          strings.speakersGroup,
                          event.target.value
                        )
                      }
                    >
                      <option value="true">{strings.yesLabel}</option>
                      <option value="false">{strings.noLabel}</option>
                    </select>
                  </td>
                  <td>
                    <select
                      className="form-control"
                      disabled={member.status !== "Enabled"}
                      id="sponsor"
                      value={member.sponsorsGroup || false}
                      onChange={(event) =>
                        this.setMemberProperty(
                          member.memberIndex,
                          strings.sponsorsGroup,
                          event.target.value
                        )
                      }
                    >
                      <option value="true">{strings.yesLabel}</option>
                      <option value="false">{strings.noLabel}</option>
                    </select>
                  </td>
                  <td>
                    <select
                      className="form-control"
                      disabled={member.status !== "Enabled"}
                      id="attendee"
                      value={member.attendeesGroup || false}
                      onChange={(event) =>
                        this.setMemberProperty(
                          member.memberIndex,
                          strings.attendeesGroup,
                          event.target.value
                        )
                      }
                    >
                      <option value="true">{strings.yesLabel}</option>
                      <option value="false">{strings.noLabel}</option>
                    </select>
                  </td>
                  <td>
                    <select
                      className="form-control"
                      disabled={member.status !== "Enabled"}
                      id="Organizer"
                      value={member.organizersGroup || false}
                      onChange={(event) =>
                        this.setMemberProperty(
                          member.memberIndex,
                          strings.organizersGroup,
                          event.target.value
                        )
                      }
                    >
                      <option value="true">{strings.yesLabel}</option>
                      <option value="false">{strings.noLabel}</option>
                    </select>
                  </td>
                  <td>
                    <input
                      type="text"
                      className="form-control text-capitalize	"
                      value={member.userId || ""}
                      placeholder="UPN"
                      disabled={this.state.isEdit}
                      onChange={(event) =>
                        this.setMemberProperty(
                          member.memberIndex,
                          strings.userId,
                          event.target.value
                        )
                      }
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="page-nav">
            <select
              value={this.state.pageSize}
              className="selectrows"
              onChange={(event: any) =>
                this.setState({ pageSize: event.target.value, selectedPage: 1 })
              }
            >
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50 ">50</option>
              <option value="100">100</option>
            </select>
            {allEditData.length > 0 &&
              allEditData?.length > this.state.pageSize &&
              this.state.isBulk && (
                <PaginationComponent
                  totalItems={allEditData.length}
                  pageSize={this.state.pageSize}
                  onSelect={(selectedPage: any) => this.setState({ selectedPage })}
                  defaultActivePage={this.state.selectedPage}
                />
              )}
          </div>
        </div>
      </div>
    );
  }

  getTitle() {
    let removedata = this.state.members.find(
      (x) => x.id === this.state.removeid
    );
    return removedata.title;
  }
  //Remove Unnecessary Aria Attributes from Multiselect dropdown
  removeAriaAttributes = (eleRef: HTMLTableCellElement | null | undefined, optionLength: number, filter: string) => {
    const selectElement = eleRef?.getElementsByClassName('dropdown-container')[0];
    selectElement?.removeAttribute('aria-expanded');
    selectElement?.removeAttribute('aria-readonly');

    const selectPanelElement = eleRef?.getElementsByClassName('select-panel')[0];

    if (filter !== "") {
      selectPanelElement?.setAttribute("role", "group");
    }
    else {
      selectPanelElement?.setAttribute("role", "listbox");
    }

    selectPanelElement?.setAttribute("aria-label", "select options");
    if (optionLength <= 0) {
      const selectAllEle = selectPanelElement?.getElementsByClassName('select-item')[0];
      selectAllEle?.setAttribute("tabindex", "0");
      const inputCheckboxEle = selectAllEle?.getElementsByTagName('input')[0];
      inputCheckboxEle?.setAttribute("tabindex", "1");
      inputCheckboxEle?.setAttribute("role", "form");
    }
    else {
      const AllOptionEle = selectPanelElement?.getElementsByClassName('select-item');
      for (let i = 0; i < (AllOptionEle === undefined || AllOptionEle === null ? 0 : AllOptionEle.length); i++) {
        if (AllOptionEle !== undefined) {
          AllOptionEle[i]?.setAttribute("tabindex", "0");
          const inputCheckboxEle = AllOptionEle[i]?.getElementsByTagName('input')[0];
          inputCheckboxEle?.setAttribute("tabindex", "1");
          inputCheckboxEle?.setAttribute("role", "form");
          if (i > 0) {
            AllOptionEle[i]?.setAttribute("role", "group");
            AllOptionEle[i]?.setAttribute("aria-label", "label" + i);
            AllOptionEle[i]?.removeAttribute("aria-selected");
          }
        }

      }
    }
  }

  filterOptions = (options: any, filter: string) => {
    return options.filter((option: any) => option.value.toLowerCase().indexOf(filter.toLowerCase()) !== -1);
  }

  handleLoading = (isLoading: boolean) => {
    this.setState({ loading: isLoading });
  }

  extractData = (data: Array<any>) => {
    try {
      let collection: Int32Array[] = [];
      data = data.filter((x) => x.length === 1);
      data[0] = data[0].map((row: string) => row.replace(/[^a-zA-Z 0-9]+/g, ""));
      if (data.length >= 2 && data[0][0].toLowerCase() === "upn") {
        data.splice(0, 1);
        let csvData = data.map((row) => { return { upn: row[0].trim() }; });
        let nodata = csvData.filter(
          (x) => !x.upn
        );
        if (nodata.length > 1) {
          this.setalertparameters(
            `${messages.CsvEmptyValueWarning}`,
            "warning",
            "Warning"
          );
          if (this.uploadedFileRef && this.uploadedFileRef.current)
            this.uploadedFileRef.current.value = "";
        } else {
          let unique = csvData.map((item) => item.upn).filter((value, index, self) => self.indexOf(value) === index);
          if (unique.length === csvData.length) {
            let previousdata = [...this.state.allFilteredData];
            if (previousdata.length > 0) {
              csvData.forEach((UPN: any) => {
                for (var i = 0; i < previousdata.length; i++) {
                  if (previousdata[i].userId != null && UPN.upn === previousdata[i].userId) {
                    this.state.checkedListAll.includes(previousdata[i].id);
                    collection.push(previousdata[i].id);
                    previousdata.unshift(previousdata[i]);
                    previousdata.splice(i + 1, 1);
                    this.setState({
                      allFilteredData: previousdata,
                      checkedListAll: collection
                    });
                    let orginalevents = Object.assign({}, this.state.allFilteredData);
                    let myevents: any = [];
                    let toindex = this.state.pageSize;
                    let fromindex = toindex - this.state.pageSize;
                    for (let i = fromindex; i < toindex; i++) {
                      if (orginalevents[i]) myevents.push(orginalevents[i]);
                    }
                    this.setState({ selectedMembers: myevents });
                  }
                }
              })
              this.setalertparameters(
                messages.selectMemberSuccess
                  .replace("{count}", `${collection.length}`),
                "success",
                "Success"
              );
            }
            if (this.uploadedFileRef && this.uploadedFileRef.current)
              this.uploadedFileRef.current.value = "";
          } else {
            this.setalertparameters(
              `${messages.CsvDuplicateValueWarning}`,
              "warning",
              "Warning"
            );
            if (this.uploadedFileRef && this.uploadedFileRef.current)
              this.uploadedFileRef.current.value = "";
          }
        }
      } else {
        this.setalertparameters(`${messages.CsvInvalidFormatError}`, "error", "Error");
        if (this.uploadedFileRef && this.uploadedFileRef.current)
          this.uploadedFileRef.current.value = "";
      }
    }
    catch {
      this.setalertparameters(`${messages.ProcessCsvError}`, "error", "Error");
    }
  }

  handleFiles = (file: File) => {
    try {
      this.handleLoading(true);
      let reader = new FileReader();
      let csvData: any;
      let that = this;
      reader.readAsText(file);
      reader.onloadend = (_event: Event) => {
        csvData = PapaParse.parse(
          reader.result as string,
          Object.assign({} as PapaParse.ParseConfig, {
            encoding: "UTF-8",
          })
        );
        this.setState({
          isOpenBulkSelect: false
        });
        that.extractData(csvData?.data ?? []);
      };
    } catch {
      this.setalertparameters(`${messages.ProcessCsvError}`, "error", "Error");
      if (this.uploadedFileRef && this.uploadedFileRef.current)
        this.uploadedFileRef.current.value = "";
    }
  }

  //Sort in Ascending Order
  private sortedAsc = (value1: any, value2: any) => {
    if (value1 === null) {
      return 1;
    }

    if (value2 === null) {
      return -1;
    }

    if (value1 === value2) {
      return 0;
    }

    return value1 < value2 ? -1 : 1;
  }

  //Sort in Descending Order
  private sortedDesc = (value1: any, value2: any) => {
    if (value1 === null) {
      return 1;
    }

    if (value2 === null) {
      return -1;
    }

    if (value1 === value2) {
      return 0;
    }

    return value1 < value2 ? 1 : -1;
  }

  //Sort Array based on column value and sort type
  public sortTableData = (columnName: string, sortByValue: string): any => {
    if (columnName === strings.createdDate || columnName === strings.guestInviteSentDate
      || columnName === strings.credentialsSentDate || columnName === strings.accountCreatedDate) {
      const memberedData = this.state.allFilteredData;
      if (sortByValue === strings.ascendingOrder) {
        memberedData.sort((a: any, b: any) => {
          const objValue1 = new Date(a[columnName]).toLocaleDateString();
          const objValue2 = new Date(b[columnName]).toLocaleDateString();
          const value1 = objValue1 === strings.invalideDate ? null : objValue1;
          const value2 = objValue2 === strings.invalideDate ? null : objValue2;
          return this.sortedAsc(value1, value2);
        });
      }
      else {
        memberedData.sort((a: any, b: any) => {
          const objValue1 = new Date(a[columnName]).toLocaleDateString();
          const objValue2 = new Date(b[columnName]).toLocaleDateString();
          const value1 = objValue1 === strings.invalideDate ? null : objValue1;
          const value2 = objValue2 === strings.invalideDate ? null : objValue2;
          return this.sortedDesc(value1, value2);
        });
      }
      this.setState({ allFilteredData: memberedData });
      this.Paginate(this.state.selectedPage);
    }
    else if (columnName === strings.country) {
      const memberedData = this.state.allFilteredData;
      if (sortByValue === strings.ascendingOrder) {
        memberedData.sort((a: any, b: any) => {
          const objValue1 = this.getCountryName(a[columnName]);
          const objValue2 = this.getCountryName(b[columnName]);
          const value1 = objValue1 === null || objValue1 === undefined || objValue1 === "" ? null : objValue1.toLowerCase();
          const value2 = objValue2 === null || objValue2 === undefined || objValue2 === "" ? null : objValue2.toLowerCase();
          return this.sortedAsc(value1, value2);
        });
      }
      else {
        memberedData.sort((a: any, b: any) => {
          const objValue1 = this.getCountryName(a[columnName]);
          const objValue2 = this.getCountryName(b[columnName]);
          const value1 = objValue1 === null || objValue1 === undefined || objValue1 === "" ? null : objValue1.toLowerCase();
          const value2 = objValue2 === null || objValue2 === undefined || objValue2 === "" ? null : objValue2.toLowerCase();
          return this.sortedDesc(value1, value2);
        });
      }
      this.setState({ allFilteredData: memberedData });
      this.Paginate(this.state.selectedPage);
    }
    else {
      const memberedData = this.state.allFilteredData;
      if (sortByValue === strings.ascendingOrder) {
        memberedData.sort((a: any, b: any) => {
          const objValue1 = a[columnName];
          const objValue2 = b[columnName];
          const value1 = objValue1 === null || objValue1 === undefined || objValue1 === "" ? null : objValue1.toLowerCase();
          const value2 = objValue2 === null || objValue2 === undefined || objValue2 === "" ? null : objValue2.toLowerCase();
          return this.sortedAsc(value1, value2);
        });
      }
      else {
        memberedData.sort((a: any, b: any) => {
          const objValue1 = a[columnName];
          const objValue2 = b[columnName];
          const value1 = objValue1 === null || objValue1 === undefined || objValue1 === "" ? null : objValue1.toLowerCase();
          const value2 = objValue2 === null || objValue2 === undefined || objValue2 === "" ? null : objValue2.toLowerCase();
          return this.sortedDesc(value1, value2);
        });
      }
      this.setState({ allFilteredData: memberedData });
      this.Paginate(this.state.selectedPage);
    }
  }


  //Sort Column on click of sort icons
  public sortColumnOrder = (columnName: string, sortByValue: string) => {
    if (this.state.allFilteredData.length > 0) {
      if (this.state.sortColumn === columnName) {
        if (sortByValue === strings.ascendingOrder) {
          this.setState({ sortColumnBy: strings.descendingOrder });
          this.sortTableData(columnName, strings.descendingOrder);
        }
        else {
          this.setState({ sortColumnBy: strings.ascendingOrder });
          this.sortTableData(columnName, strings.ascendingOrder);
        }

      }

      else {
        this.setState({ sortColumn: columnName, sortColumnBy: strings.ascendingOrder });
        this.sortTableData(columnName, strings.ascendingOrder);
      }
    }
  }

  render() {
    const { ItemsChecked, selectedDropdown, isUpdateDisabled } = this.state;
    return (
      <div style={{ width: "100%" }}>
        <Header isTos={false} />
        {this.state.iseditbarShow && (
          <div className="mt-3 card cd">
            <h5>
              <div className="float-left">
                {this.state.selectedMembers.length > 0 &&
                  this.props.memList !== "Owners" && (
                    <button
                      className="primary expt send"
                      onClick={() => this.setState({ isOpenBulkSelect: true })}
                    >
                      Bulk Select
                    </button>
                  )}
              </div>
              <div className="float-right">
                {(this.state.isBulk || this.state.isEdit) && (
                  <>
                    <button className="update" disabled={isUpdateDisabled} onClick={this.updateRow}>
                      Update
                    </button>
                    <button className="cancel" onClick={this.cancelRow}>
                      Cancel
                    </button>
                  </>
                )}
                {this.state.selectedMembers.length > 0 && (
                  <button
                    className="primary expt"
                    disabled={this.state.isBulk || this.state.isEdit}
                    onClick={() =>
                      this.exportToCSV(this.state.members, "Memberslist")
                    }
                  >
                    Export
                  </button>
                )}
                {this.state.selectedMembers.length > 0 && (
                  <button
                    className="primary expt send"
                    onClick={this.editData}
                    disabled={this.state.isBulk || this.state.isEdit}
                  >
                    Edit
                  </button>
                )}

                {this.state.selectedMembers.length > 0 && (
                  <button
                    className="primary expt send"
                    onClick={this.removeClick}
                    disabled={this.state.isBulk || this.state.isEdit}
                  >
                    Remove
                  </button>
                )}
                {this.state.selectedMembers.length > 0 && (
                  <button
                    className="primary expt send"
                    onClick={this.resendCredClick}
                    disabled={this.state.isBulk || this.state.isEdit}
                  >
                    Resend Credentials
                  </button>
                )}
                {this.state.selectedMembers.length > 0 &&
                  this.props.memList !== "Owners" && (
                    <button
                      className="primary expt send"
                      onClick={this.resendInvitaion}
                      disabled={this.state.isBulk || this.state.isEdit}
                    >
                      Resend Invitation
                    </button>
                  )}
              </div>
            </h5>

            {this.state.isBulk === false && !this.state.isEdit && (
              <table
                className={
                  this.inTeams()
                    ? "table table-responsive"
                    : "table table-responsive"
                }
                style={{ minHeight: "241px" }}
                ref={this.tableref}
              >
                <thead className="">
                  <tr id={"scroll-to-bottom"} className="memberlistheader">
                    <th>
                      <label>
                        <input
                          type="checkbox"
                          checked={ItemsChecked}
                          onChange={this.selectItem.bind(this)}
                          aria-label='select all checkbox'
                        />
                        <span></span>
                      </label>
                    </th>
                    <th >
                      <div className="head-layout">
                        <div ref={this.dateRequestedRef}>
                          <MultiSelect
                            options={this.getOptions(strings.createdDate)}
                            value={_.get(selectedDropdown, strings.createdDate, [])}
                            labelledBy={"DateRequested"}
                            overrideStrings={{ selectSomeItems: "Date Requested" }}
                            onChange={(newOptions: any) => {
                              this.applyFilter(strings.createdDate, newOptions);
                            }}
                            onMenuToggle={() => {
                              this.removeAriaAttributes(this.dateRequestedRef?.current, this.getOptions(strings.createdDate).length, "");
                            }}
                            filterOptions={(options: any, filter: string) => {
                              this.removeAriaAttributes(this.dateRequestedRef?.current, this.getOptions(strings.createdDate).length, filter);
                              return this.filterOptions(options, filter);
                            }}
                          />
                        </div>
                        <div
                          className="sort-layout"
                          onClick={(eve: any) => this.sortColumnOrder(strings.createdDate, this.state.sortColumnBy)}
                        >
                          <Icon.ArrowUp
                            color={(this.state.sortColumn === strings.createdDate && this.state.sortColumnBy === strings.ascendingOrder) ? "#01265d" : "gray"}
                            fontWeight={800}
                          />
                          <Icon.ArrowDown
                            color={(this.state.sortColumn === strings.createdDate && this.state.sortColumnBy === strings.descendingOrder) ? "#01265d" : "gray"}
                            fontWeight={800}
                          />
                        </div>
                      </div>
                    </th>
                    {this.props.memList === "Members" && (
                      <th >
                        <div className="head-layout">
                          <div ref={this.accountTypeRef}>
                            <MultiSelect
                              options={this.getOptions(strings.accountType)}
                              value={_.get(selectedDropdown, strings.accountType, [])}
                              labelledBy={"Account Type"}
                              overrideStrings={{ selectSomeItems: "Account Type" }}
                              onChange={(newOptions: any) =>
                                this.applyFilter(strings.accountType, newOptions)
                              }
                              onMenuToggle={() => {
                                this.removeAriaAttributes(this.accountTypeRef?.current, this.getOptions(strings.accountType).length, "");
                              }}
                              filterOptions={(options: any, filter: string) => {
                                this.removeAriaAttributes(this.accountTypeRef?.current, this.getOptions(strings.accountType).length, filter);
                                return this.filterOptions(options, filter);
                              }}
                            />
                          </div>
                          <div
                            className="sort-layout"
                            onClick={(eve: any) => this.sortColumnOrder(strings.accountType, this.state.sortColumnBy)}
                          >
                            <Icon.ArrowUp
                              color={(this.state.sortColumn === strings.accountType && this.state.sortColumnBy === strings.ascendingOrder) ? "#01265d" : "gray"}
                              fontWeight={800}
                            />
                            <Icon.ArrowDown
                              color={(this.state.sortColumn === strings.accountType && this.state.sortColumnBy === strings.descendingOrder) ? "#01265d" : "gray"}
                              fontWeight={800}
                            />
                          </div>
                        </div>
                      </th>
                    )}
                    <th >
                      <div className="head-layout">
                        <div ref={this.statusRef}>
                          <MultiSelect
                            options={this.getOptions(strings.status)}
                            value={_.get(selectedDropdown, strings.status, [])}
                            labelledBy={"Status"}
                            overrideStrings={{ selectSomeItems: "Status" }}
                            onChange={(newOptions: any) =>
                              this.applyFilter(strings.status, newOptions)
                            }
                            onMenuToggle={() => {
                              this.removeAriaAttributes(this.statusRef?.current, this.getOptions(strings.status).length, "");
                            }}
                            filterOptions={(options: any, filter: string) => {
                              this.removeAriaAttributes(this.statusRef?.current, this.getOptions(strings.status).length, filter);
                              return this.filterOptions(options, filter);
                            }}
                          />
                        </div>
                        <div
                          className="sort-layout"
                          onClick={(eve: any) => this.sortColumnOrder(strings.status, this.state.sortColumnBy)}
                        >
                          <Icon.ArrowUp
                            color={(this.state.sortColumn === strings.status && this.state.sortColumnBy === strings.ascendingOrder) ? "#01265d" : "gray"}
                            fontWeight={800}
                          />
                          <Icon.ArrowDown
                            color={(this.state.sortColumn === strings.status && this.state.sortColumnBy === strings.descendingOrder) ? "#01265d" : "gray"}
                            fontWeight={800}
                          />
                        </div>
                      </div>

                    </th>
                    <th >
                      <div className="head-layout">
                        <div ref={this.emailRef}>
                          <MultiSelect
                            options={this.getOptions(strings.title)}
                            value={_.get(selectedDropdown, strings.title, [])}
                            labelledBy={"Email"}
                            overrideStrings={{ selectSomeItems: "Email" }}
                            onChange={(newOptions: any) =>
                              this.applyFilter(strings.title, newOptions)
                            }
                            onMenuToggle={() => {
                              this.removeAriaAttributes(this.emailRef?.current, this.getOptions(strings.title).length, "");
                            }}
                            filterOptions={(options: any, filter: string) => {
                              this.removeAriaAttributes(this.emailRef?.current, this.getOptions(strings.title).length, filter);
                              return this.filterOptions(options, filter);
                            }}
                          />
                        </div>
                        <div
                          className="sort-layout"
                          onClick={(eve: any) => this.sortColumnOrder(strings.title, this.state.sortColumnBy)}
                        >
                          <Icon.ArrowUp
                            color={(this.state.sortColumn === strings.title && this.state.sortColumnBy === strings.ascendingOrder) ? "#01265d" : "gray"}
                            fontWeight={800}
                          />
                          <Icon.ArrowDown
                            color={(this.state.sortColumn === strings.title && this.state.sortColumnBy === strings.descendingOrder) ? "#01265d" : "gray"}
                            fontWeight={800}
                          />
                        </div>
                      </div>

                    </th>
                    <th >
                      <div className="head-layout">
                        <div ref={this.firstNameRef}>
                          <MultiSelect
                            options={this.getOptions(strings.firstName)}
                            value={_.get(selectedDropdown, strings.firstName, [])}
                            labelledBy={"DateRequested"}
                            overrideStrings={{ selectSomeItems: "First Name" }}
                            onChange={(newOptions: any) =>
                              this.applyFilter(strings.firstName, newOptions)
                            }
                            onMenuToggle={() => {
                              this.removeAriaAttributes(this.firstNameRef?.current, this.getOptions(strings.firstName).length, "");
                            }}
                            filterOptions={(options: any, filter: string) => {
                              this.removeAriaAttributes(this.firstNameRef?.current, this.getOptions(strings.firstName).length, filter);
                              return this.filterOptions(options, filter);
                            }}
                          />
                        </div>
                        <div
                          className="sort-layout"
                          onClick={(eve: any) => this.sortColumnOrder(strings.firstName, this.state.sortColumnBy)}
                        >
                          <Icon.ArrowUp
                            color={(this.state.sortColumn === strings.firstName && this.state.sortColumnBy === strings.ascendingOrder) ? "#01265d" : "gray"}
                            fontWeight={800}
                          />
                          <Icon.ArrowDown
                            color={(this.state.sortColumn === strings.firstName && this.state.sortColumnBy === strings.descendingOrder) ? "#01265d" : "gray"}
                            fontWeight={800}
                          />
                        </div>
                      </div>

                    </th>
                    <th >
                      <div className="head-layout">
                        <div ref={this.lastNameRef}>
                          <MultiSelect
                            options={this.getOptions(strings.lastName)}
                            value={_.get(selectedDropdown, strings.lastName, [])}
                            labelledBy={"LastName"}
                            overrideStrings={{ selectSomeItems: "Last Name" }}
                            onChange={(newOptions: any) =>
                              this.applyFilter(strings.lastName, newOptions)
                            }
                            onMenuToggle={() => {
                              this.removeAriaAttributes(this.lastNameRef?.current, this.getOptions(strings.lastName).length, "");
                            }}
                            filterOptions={(options: any, filter: string) => {
                              this.removeAriaAttributes(this.lastNameRef?.current, this.getOptions(strings.lastName).length, filter);
                              return this.filterOptions(options, filter);
                            }}
                          />
                        </div>
                        <div
                          className="sort-layout"
                          onClick={(eve: any) => this.sortColumnOrder(strings.lastName, this.state.sortColumnBy)}
                        >
                          <Icon.ArrowUp
                            color={(this.state.sortColumn === strings.lastName && this.state.sortColumnBy === strings.ascendingOrder) ? "#01265d" : "gray"}
                            fontWeight={800}
                          />
                          <Icon.ArrowDown
                            color={(this.state.sortColumn === strings.lastName && this.state.sortColumnBy === strings.descendingOrder) ? "#01265d" : "gray"}
                            fontWeight={800}
                          />
                        </div>
                      </div>

                    </th>
                    <th >
                      <div className="head-layout">
                        <div ref={this.displayNameRef}>
                          <MultiSelect
                            options={this.getOptions(strings.disName)}
                            value={_.get(selectedDropdown, strings.disName, [])}
                            labelledBy={"DisplayName"}
                            overrideStrings={{ selectSomeItems: "Display Name" }}
                            onChange={(newOptions: any) =>
                              this.applyFilter(strings.disName, newOptions)
                            }
                            onMenuToggle={() => {
                              this.removeAriaAttributes(this.displayNameRef?.current, this.getOptions(strings.disName).length, "");
                            }}
                            filterOptions={(options: any, filter: string) => {
                              this.removeAriaAttributes(this.displayNameRef?.current, this.getOptions(strings.disName).length, filter);
                              return this.filterOptions(options, filter);
                            }}
                          />
                        </div>
                        <div
                          className="sort-layout"
                          onClick={(eve: any) => this.sortColumnOrder(strings.disName, this.state.sortColumnBy)}
                        >
                          <Icon.ArrowUp
                            color={(this.state.sortColumn === strings.disName && this.state.sortColumnBy === strings.ascendingOrder) ? "#01265d" : "gray"}
                            fontWeight={800}
                          />
                          <Icon.ArrowDown
                            color={(this.state.sortColumn === strings.disName && this.state.sortColumnBy === strings.descendingOrder) ? "#01265d" : "gray"}
                            fontWeight={800}
                          />
                        </div>
                      </div>
                    </th>
                    <th>
                      <div className="head-layout">
                        <div ref={this.countryRef}>
                          <MultiSelect
                            options={this.getOptions(strings.country)}
                            value={_.get(selectedDropdown, strings.country, [])}
                            labelledBy={"Country"}
                            overrideStrings={{ selectSomeItems: "Country" }}
                            onChange={(newOptions: any) =>
                              this.applyFilter(strings.country, newOptions)
                            }
                            onMenuToggle={() => {
                              this.removeAriaAttributes(this.countryRef?.current, this.getOptions(strings.country).length, "");
                            }}
                            filterOptions={(options: any, filter: string) => {
                              this.removeAriaAttributes(this.countryRef?.current, this.getOptions(strings.country).length, filter);
                              return this.filterOptions(options, filter);
                            }}
                          />
                        </div>
                        <div
                          className="sort-layout"
                          onClick={(eve: any) => this.sortColumnOrder(strings.country, this.state.sortColumnBy)}
                        >
                          <Icon.ArrowUp
                            color={(this.state.sortColumn === strings.country && this.state.sortColumnBy === strings.ascendingOrder) ? "#01265d" : "gray"}
                            fontWeight={800}
                          />
                          <Icon.ArrowDown
                            color={(this.state.sortColumn === strings.country && this.state.sortColumnBy === strings.descendingOrder) ? "#01265d" : "gray"}
                            fontWeight={800}
                          />
                        </div>
                      </div>
                    </th>
                    <th >
                      <div className="head-layout">
                        <div ref={this.companyRef}>
                          <MultiSelect
                            options={this.getOptions(strings.company)}
                            value={_.get(selectedDropdown, strings.company, [])}
                            labelledBy={"Company"}
                            overrideStrings={{ selectSomeItems: "Company" }}
                            onChange={(newOptions: any) =>
                              this.applyFilter(strings.company, newOptions)
                            }
                            onMenuToggle={() => {
                              this.removeAriaAttributes(this.companyRef?.current, this.getOptions(strings.company).length, "");
                            }}
                            filterOptions={(options: any, filter: string) => {
                              this.removeAriaAttributes(this.companyRef?.current, this.getOptions(strings.company).length, filter);
                              return this.filterOptions(options, filter);
                            }}
                          />
                        </div>
                        <div
                          className="sort-layout"
                          onClick={(eve: any) => this.sortColumnOrder(strings.company, this.state.sortColumnBy)}
                        >
                          <Icon.ArrowUp
                            color={(this.state.sortColumn === strings.company && this.state.sortColumnBy === strings.ascendingOrder) ? "#01265d" : "gray"}
                            fontWeight={800}
                          />
                          <Icon.ArrowDown
                            color={(this.state.sortColumn === strings.company && this.state.sortColumnBy === strings.descendingOrder) ? "#01265d" : "gray"}
                            fontWeight={800}
                          />
                        </div>
                      </div>
                    </th>
                    <th>
                      <div ref={this.speakersGroupRef}>
                        <MultiSelect
                          options={[
                            { label: strings.yesLabel, value: "true" },
                            { label: strings.noLabel, value: "false" },
                          ]}
                          value={_.get(selectedDropdown, strings.speakersGroup, [])}
                          labelledBy={"Speakers Group"}
                          overrideStrings={{ selectSomeItems: "Speakers Group" }}
                          onChange={(newOptions: any) =>
                            this.applyFilter(strings.speakersGroup, newOptions)
                          }
                          onMenuToggle={() => {
                            this.removeAriaAttributes(this.speakersGroupRef?.current, 2, "");
                          }}
                          filterOptions={(options: any, filter: string) => {
                            this.removeAriaAttributes(this.speakersGroupRef?.current, 2, filter);
                            return this.filterOptions(options, filter);
                          }}
                        />
                      </div>
                    </th>
                    <th>
                      <div ref={this.sponsorsGroupRef}>
                        <MultiSelect
                          options={[
                            { label: strings.yesLabel, value: "true" },
                            { label: strings.noLabel, value: "false" },
                          ]}
                          value={_.get(selectedDropdown, strings.sponsorsGroup, [])}
                          labelledBy={"Sponsers Group"}
                          overrideStrings={{ selectSomeItems: "Sponsers Group" }}
                          onChange={(newOptions: any) =>
                            this.applyFilter(strings.sponsorsGroup, newOptions)
                          }
                          onMenuToggle={() => {
                            this.removeAriaAttributes(this.sponsorsGroupRef?.current, 2, "");
                          }}
                          filterOptions={(options: any, filter: string) => {
                            this.removeAriaAttributes(this.sponsorsGroupRef?.current, 2, filter);
                            return this.filterOptions(options, filter);
                          }}
                        />
                      </div>
                    </th>
                    <th>
                      <div ref={this.attendeesGroupRef}>
                        <MultiSelect
                          options={[
                            { label: strings.yesLabel, value: "true" },
                            { label: strings.noLabel, value: "false" },
                          ]}
                          value={_.get(selectedDropdown, strings.attendeesGroup, [])}
                          labelledBy={"Attendees Group"}
                          overrideStrings={{ selectSomeItems: "Attendees Group" }}
                          onChange={(newOptions: any) =>
                            this.applyFilter(strings.attendeesGroup, newOptions)
                          }
                          onMenuToggle={() => {
                            this.removeAriaAttributes(this.attendeesGroupRef?.current, 2, "");
                          }}
                          filterOptions={(options: any, filter: string) => {
                            this.removeAriaAttributes(this.attendeesGroupRef?.current, 2, filter);
                            return this.filterOptions(options, filter);
                          }}
                        />
                      </div>
                    </th>
                    <th >
                      <div ref={this.organizersGroupRef}>
                        <MultiSelect
                          options={[
                            { label: strings.yesLabel, value: "true" },
                            { label: strings.noLabel, value: "false" },
                          ]}
                          value={_.get(selectedDropdown, strings.organizersGroup, [])}
                          labelledBy={"Organizers Group"}
                          overrideStrings={{
                            selectSomeItems: "Organizers Group",
                          }}
                          onChange={(newOptions: any) =>
                            this.applyFilter(strings.organizersGroup, newOptions)
                          }
                          onMenuToggle={() => {
                            this.removeAriaAttributes(this.organizersGroupRef?.current, 2, "");
                          }}
                          filterOptions={(options: any, filter: string) => {
                            this.removeAriaAttributes(this.organizersGroupRef?.current, 2, filter);
                            return this.filterOptions(options, filter);
                          }}
                        />
                      </div>
                    </th>
                    <th>
                      <div className="head-layout">
                        <div ref={this.userIdRef}>
                          <MultiSelect
                            options={this.getOptions(strings.userId)}
                            value={_.get(selectedDropdown, strings.userId, [])}
                            labelledBy={"DateRequested"}
                            overrideStrings={{ selectSomeItems: "UPN" }}
                            onChange={(newOptions: any) =>
                              this.applyFilter(strings.userId, newOptions)
                            }
                            onMenuToggle={() => {
                              this.removeAriaAttributes(this.userIdRef?.current, this.getOptions(strings.userId).length, "");
                            }}
                            filterOptions={(options: any, filter: string) => {
                              this.removeAriaAttributes(this.userIdRef?.current, this.getOptions(strings.userId).length, filter);
                              return this.filterOptions(options, filter);
                            }}
                          />
                        </div>
                        <div
                          className="sort-layout"
                          onClick={(eve: any) => this.sortColumnOrder(strings.userId, this.state.sortColumnBy)}
                        >
                          <Icon.ArrowUp
                            color={(this.state.sortColumn === strings.userId && this.state.sortColumnBy === strings.ascendingOrder) ? "#01265d" : "gray"}
                            fontWeight={800}
                          />
                          <Icon.ArrowDown
                            color={(this.state.sortColumn === strings.userId && this.state.sortColumnBy === strings.descendingOrder) ? "#01265d" : "gray"}
                            fontWeight={800}
                          />
                        </div>

                      </div>

                    </th>
                    <th>
                      <div className="head-layout">
                        <div ref={this.accountCreatedDateRef}>
                          <MultiSelect
                            options={this.getOptions(strings.accountCreatedDate)}
                            value={_.get(
                              selectedDropdown,
                              strings.accountCreatedDate,
                              []
                            )}
                            labelledBy={"Account Created"}
                            overrideStrings={{ selectSomeItems: "Account Created" }}
                            onChange={(newOptions: any) =>
                              this.applyFilter(strings.accountCreatedDate, newOptions)
                            }
                            onMenuToggle={() => {
                              this.removeAriaAttributes(this.accountCreatedDateRef?.current, this.getOptions(strings.accountCreatedDate).length, "");
                            }}
                            filterOptions={(options: any, filter: string) => {
                              this.removeAriaAttributes(this.accountCreatedDateRef?.current, this.getOptions(strings.accountCreatedDate).length, filter);
                              return this.filterOptions(options, filter);
                            }}
                          />

                        </div>
                        <div
                          className="sort-layout"
                          onClick={(eve: any) => this.sortColumnOrder(strings.accountCreatedDate, this.state.sortColumnBy)}
                        >
                          <Icon.ArrowUp
                            color={(this.state.sortColumn === strings.accountCreatedDate && this.state.sortColumnBy === strings.ascendingOrder) ? "#01265d" : "gray"}
                            fontWeight={800}
                          />
                          <Icon.ArrowDown
                            color={(this.state.sortColumn === strings.accountCreatedDate && this.state.sortColumnBy === strings.descendingOrder) ? "#01265d" : "gray"}
                            fontWeight={800}
                          />
                        </div>
                      </div>

                    </th>
                    <th>
                      <div className="head-layout">
                        <div ref={this.credentialsSentDateRef}>
                          <MultiSelect
                            options={this.getOptions(strings.credentialsSentDate)}
                            value={_.get(
                              selectedDropdown,
                              strings.credentialsSentDate,
                              []
                            )}
                            labelledBy={"Credentials Sent"}
                            overrideStrings={{
                              selectSomeItems: "Credentials Sent",
                            }}
                            onChange={(newOptions: any) =>
                              this.applyFilter(strings.credentialsSentDate, newOptions)
                            }
                            onMenuToggle={() => {
                              this.removeAriaAttributes(this.credentialsSentDateRef?.current, this.getOptions(strings.credentialsSentDate).length, "");
                            }}
                            filterOptions={(options: any, filter: string) => {
                              this.removeAriaAttributes(this.credentialsSentDateRef?.current, this.getOptions(strings.credentialsSentDate).length, filter);
                              return this.filterOptions(options, filter);
                            }}
                          />
                        </div>
                        <div
                          className="sort-layout"
                          onClick={(eve: any) => this.sortColumnOrder(strings.credentialsSentDate, this.state.sortColumnBy)}
                        >
                          <Icon.ArrowUp
                            color={(this.state.sortColumn === strings.credentialsSentDate && this.state.sortColumnBy === strings.ascendingOrder) ? "#01265d" : "gray"}
                            fontWeight={800}
                          />
                          <Icon.ArrowDown
                            color={(this.state.sortColumn === strings.credentialsSentDate && this.state.sortColumnBy === strings.descendingOrder) ? "#01265d" : "gray"}
                            fontWeight={800}
                          />
                        </div>
                      </div>
                    </th>
                    <th >
                      <div className="head-layout">
                        <div ref={this.guestInviteSentDateRef}>
                          <MultiSelect
                            options={this.getOptions(strings.guestInviteSentDate)}
                            value={_.get(
                              selectedDropdown,
                              strings.guestInviteSentDate,
                              []
                            )}
                            labelledBy={"Guest Invitation Sent"}
                            overrideStrings={{
                              selectSomeItems: "Guest Invitation Sent",
                            }}
                            onChange={(newOptions: any) =>
                              this.applyFilter(strings.guestInviteSentDate, newOptions)
                            }
                            onMenuToggle={() => {
                              this.removeAriaAttributes(this.guestInviteSentDateRef?.current, this.getOptions(strings.guestInviteSentDate).length, "");
                            }}
                            filterOptions={(options: any, filter: string) => {
                              this.removeAriaAttributes(this.guestInviteSentDateRef?.current, this.getOptions(strings.guestInviteSentDate).length, filter);
                              return this.filterOptions(options, filter);
                            }}
                          />
                        </div>
                        <div
                          className="sort-layout"
                          onClick={(eve: any) => this.sortColumnOrder(strings.guestInviteSentDate, this.state.sortColumnBy)}
                        >
                          <Icon.ArrowUp
                            color={(this.state.sortColumn === strings.guestInviteSentDate && this.state.sortColumnBy === strings.ascendingOrder) ? "#01265d" : "gray"}
                            fontWeight={800}
                          />
                          <Icon.ArrowDown
                            color={(this.state.sortColumn === strings.guestInviteSentDate && this.state.sortColumnBy === strings.descendingOrder) ? "#01265d" : "gray"}
                            fontWeight={800}
                          />
                        </div>
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.selectedMembers.map((member, inx) => (
                    <tr key={inx}>
                      <td>
                        <label>
                          <input
                            type="checkbox"
                            value={member.id || ""}
                            checked={
                              this.state.checkedListAll.includes(member.id) &&
                              member.id
                            }
                            onChange={this.handleCheckboxClick}
                            aria-label={'select checkbox' + member.id}
                          />
                          <span></span>
                        </label>
                      </td>
                      <td>
                        {new Date(member.createdDate).toLocaleDateString() !==
                          strings.invalideDate
                          ? new Date(member.createdDate).toDateString()
                          : ""}
                      </td>
                      {this.props.memList === "Members" && (
                        <td>{member.accountType}</td>
                      )}
                      <td>{member.status}</td>
                      <td>{member.title}</td>
                      <td>{member.firstName}</td>
                      <td>{member.lastName}</td>
                      <td>{member.disName}</td>
                      <td>{this.getCountryName(member.country)}</td>
                      <td>{member.company}</td>
                      <td>{member.speakersGroup ? strings.yesLabel : strings.noLabel}</td>
                      <td>{member.sponsorsGroup ? strings.yesLabel : strings.noLabel}</td>
                      <td>{member.attendeesGroup ? strings.yesLabel : strings.noLabel}</td>
                      <td>{member.organizersGroup ? strings.yesLabel : strings.noLabel}</td>
                      <td>{member.userId}</td>
                      <td>
                        {new Date(
                          member.accountCreatedDate
                        ).toLocaleDateString() !== strings.invalideDate
                          ? new Date(member.accountCreatedDate).toDateString()
                          : ""}
                      </td>
                      <td>
                        {new Date(
                          member.credentialsSentDate
                        ).toLocaleDateString() !== strings.invalideDate
                          ? new Date(member.credentialsSentDate).toDateString()
                          : ""}
                      </td>
                      <td>
                        {new Date(
                          member.guestInviteSentDate
                        ).toLocaleDateString() !== strings.invalideDate
                          ? new Date(member.guestInviteSentDate).toDateString()
                          : ""}
                      </td>
                    </tr >
                  ))
                  }
                </tbody>
              </table >
            )}
            <div className="page-nav">
              {!this.state.isBulk && !this.state.isEdit && (
                <select
                  value={this.state.pageSize}
                  className="selectrows"
                  onChange={(event) =>
                    this.rowsSet(event, this.state.allFilteredData, false)
                  }
                  aria-label="select number of rows to display"
                >
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50 ">50</option>
                  <option value="100">100</option>
                </select>
              )}
              {this.state.members.length > 0 &&
                this.state.allFilteredData?.length > this.state.pageSize &&
                !this.state.isBulk &&
                !this.state.isEdit && (
                  <PaginationComponent
                    totalItems={this.state.allFilteredData?.length}
                    pageSize={this.state.pageSize}
                    onSelect={this.Paginate}
                    defaultActivePage={this.state.selectedPage}
                  />
                )}
            </div>

            {
              this.state.isEdit === true && (
                <React.Fragment>
                  {this.addMembers(this.props.memList)}
                </React.Fragment>
              )
            }
            {
              this.state.showalert && (
                <CAlert
                  message={this.state.alertmessage}
                  heading={this.state.alertheading}
                  type={this.state.alerttype}
                  closecallback={() => this.setState({ showalert: false })}
                />
              )
            }
            <Modal
              size="sm"
              show={this.state.removeid !== ""}
              dialogClassName="modal-90w"
              aria-labelledby="example-custom-modal-styling-title"
            >
              <Modal.Header>
                <Modal.Title id="example-custom-modal-styling-title">
                  Confirmation
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {messages.removeConfirmation}
              </Modal.Body>
              <Modal.Footer>
                <Button variant="danger" onClick={this.Remove}>
                  OK
                </Button>
                <Button
                  variant="primary"
                  onClick={() => {
                    this.setState({ removeid: "" });
                  }}
                >
                  Cancel
                </Button>
              </Modal.Footer>
            </Modal>

            <Modal
              size="sm"
              show={this.state.sendcredentials}
              dialogClassName="modal-90w"
              aria-labelledby="example-custom-modal-styling-title"
            >
              <Modal.Header>
                <Modal.Title id="example-custom-modal-styling-title">
                  Confirmation
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>{`${messages.resendCredentialConfirmation
                 }`}</p>
                <br />
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="primary"
                  onClick={() =>
                    this.sendCredentials(this.state.checkedListAll)
                  }
                >
                  Send
                </Button>
                <Button
                  variant="secondary"
                  onClick={() => {
                    this.setState({
                      sendcredentials: false,
                      checkedListAll: [],
                      ItemsChecked: false,
                    });
                  }}
                >
                  Cancel
                </Button>
              </Modal.Footer>
            </Modal>

            <Modal
              size="sm"
              show={this.state.sendInvitaion}
              dialogClassName="modal-90w"
              aria-labelledby="example-custom-modal-styling-title"

            >
              <Modal.Header>
                <Modal.Title id="example-custom-modal-styling-title">
                  Confirmation
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>{`${messages.resendGuestInvitationUrlConfirmation
                 }`}</p>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="primary"
                  onClick={() =>
                    this.sendResendInvitaion(this.state.checkedListAll)
                  }
                >
                  Send
                </Button>
                <Button
                  variant="secondary"
                  onClick={() => {
                    this.setState({
                      sendInvitaion: false,
                      checkedListAll: [],
                      ItemsChecked: false,
                    });
                  }}
                >
                  Cancel
                </Button>
              </Modal.Footer>
            </Modal>

            <Modal show={this.state.isOpenBulkSelect}
              onHide={() => this.setState({ isOpenBulkSelect: false })}
              centered={true}
              backdrop={true}
              dialogClassName="modal-90w">
              <Modal.Header>
                <Modal.Title id="example-custom-modal-styling-title">
                  {messages.bulkSelectHeaderText}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <h5>
                  <div>
                    <input
                      id="uploadFile"
                      type="file"
                      accept=".csv"
                      className="file"
                      ref={this.uploadedFileRef}
                      onChange={(evt: any) => this.handleFiles(evt.target.files[0])}
                      disabled={!this.state.selectedgroupId}
                      aria-label="input upload file"
                      hidden={this.props.memList.toLowerCase().includes("owners")}
                    />
                  </div>
                </h5>
                <div className="float-left">
                  <button className="sampleref" onClick={() => this.exportToCSV(this.state.members, "memberupns")} hidden={this.props.memList.toLowerCase().includes("owners")}>
                    {messages.bulkSelectUploadText}
                  </button>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button className="float-right"
                  variant="secondary"
                  onClick={() => {
                    this.setState({
                      isOpenBulkSelect: false
                    });
                  }}
                >
                  Cancel
                </Button>
              </Modal.Footer>
            </Modal>
          </div >
        )}
      </div >
    );
  }
}